import {
  Color,
  ComboboxSingleSelect
} from '@eggplant/pattern-library'
import { regionOptions } from './constants'

interface Props {
  initialOptions?: {
    label: string
    value: string
  }[]
  isRequired?: boolean
  onChange: (value: string) => void
  placeholder?: string
  value: string
  isDisabled?: boolean
}

const SelectXrayRegion = ({
  initialOptions = [],
  isRequired = false,
  onChange,
  placeholder = 'Select region',
  value,
  isDisabled
}: Props) => {
  const currentOption = regionOptions.find(item => item.value === value)

  const buttonText = currentOption?.value
    ? currentOption.label
    : placeholder

  const customPrompt = !value
    ? (
      <Color variant='theme-description-text'>
        {buttonText}
      </Color>
    )
    : buttonText

  return (
    <ComboboxSingleSelect
      customPrompt={customPrompt}
      initialOptions={initialOptions}
      isDisabled={isDisabled}
      isHighlighted={false}
      isRequired={isRequired}
      key={value}
      onChange={onChange}
      options={regionOptions}
      prompt={buttonText}
      value={value}
    />
  )
}

export default SelectXrayRegion
